import React from "react";
import { useReveal } from "../hooks/useReveal";

export default function About() {
  const ref1 = useReveal();
  const ref2 = useReveal();
  const ref3 = useReveal();

  return (
    <section
      id="ueber-uns"
      data-testid="about-section"
      className="relative py-24 md:py-32 px-6 overflow-hidden"
    >
      {/* subtle decorative blur */}
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-sky/10 blur-[120px]" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-gold/10 blur-[120px]" />

      <div className="max-w-7xl mx-auto relative">
        <div className="text-center mb-16 reveal" ref={ref1}>
          <p className="text-gold tracking-[0.4em] text-xs uppercase mb-4">Über uns</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white">
            Eine Reise nach <span className="italic text-gradient-gold">Griechenland</span>
          </h2>
          <div className="gold-divider w-24 mx-auto mt-6" />
        </div>

        <div className="grid md:grid-cols-12 gap-8 items-stretch">
          <div className="md:col-span-7 reveal" ref={ref2}>
            <div className="glass-panel rounded-2xl p-8 md:p-12 h-full">
              <h3 className="font-serif text-2xl md:text-3xl text-gold mb-6">Tradition trifft Gastfreundschaft</h3>
              <p className="text-white/80 leading-relaxed text-lg mb-5">
                Im Restaurant Poseidon im Herzen von Viechtach erleben Sie die
                wahre Seele Griechenlands. Vom ersten Schluck Ouzo bis zum
                letzten Bissen Mousakas verwöhnen wir Sie mit Rezepten, die seit
                Generationen weitergegeben werden.
              </p>
              <p className="text-white/75 leading-relaxed">
                Frische Zutaten aus dem Mittelmeerraum, sorgfältig ausgewählte
                Olivenöle, würziger Feta, zartes Lamm und feinster Fisch vom
                Grill – jedes Gericht ist eine kleine Hommage an die griechische
                Lebensart. Lassen Sie sich von unserer herzlichen Atmosphäre
                verzaubern – als wären Sie an der Küste der Ägäis.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                {["Frische vom Grill", "Hausgemachte Soßen", "Familienrezepte", "Mediterrane Atmosphäre"].map((t) => (
                  <span key={t} className="px-4 py-1.5 rounded-full text-xs tracking-wide bg-gold/10 text-gold border border-gold/30">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-4 reveal" ref={ref3}>
            <div className="rounded-2xl overflow-hidden col-span-2 h-56 md:h-64 group">
              <img
                src="/images/food5.jpg"
                alt="Griechische Spezialitäten – Scampi, Kalamari, Pommes"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="rounded-2xl overflow-hidden h-44 md:h-52 group">
              <img
                src="/images/food1.jpg"
                alt="Pita mit Tzatziki"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="rounded-2xl overflow-hidden h-44 md:h-52 group">
              <img
                src="/images/food2.jpg"
                alt="Kalamari Salat"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
